
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class VendorService extends BaseService {

    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "Vendor/";
    }

    get(id: string): Observable<any> {
        let headers = this.getHeaders();
        return this._http.get(this.baseUrl + "GetSupplier/" + id, { headers: headers });
    }

    getSupplierLocation(id: string): Observable<any> {
        let headers = this.getHeaders();
        return this._http.get(this.baseUrl + "GetSupplierLocation/" + id, { headers: headers });
    }
    getSupplierPartTypeMarkUps(id: string): Observable<any> {
        let headers = this.getHeaders();
        return this._http.get(this.baseUrl + "GetSupplierPartTypeMarkUps/" + id, { headers: headers });
    }
    saveSupplier(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveSupplier";
        return this._http.put(url_call, model, { headers });
    }

    saveSupplierLocation(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveSupplierLocation";
        return this._http.put(url_call, model, { headers });
    }
}
